// LandingPage.js
import React from 'react';
import Header from '../components/header/Header';
import Footer from '../components/footer/Footer';
import PurchasePolicy from '../components/purchase-policy/PurchasePolicy';

const PurchasePolicyPage = () => {
  return (
    <div>
      <Header />
      <PurchasePolicy />
      <Footer />
    </div>
  );
};

export default PurchasePolicyPage;
